var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4976_2403",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 23.621L7.44029 18.0597L8.55129 16.9299L12.2143 20.5929L12.2143 7L13.7857 7L13.7857 20.5929L17.4471 16.9314L18.5597 18.0597L13 23.621ZM4.53786 29C3.815 29 3.21157 28.758 2.72757 28.274C2.24252 27.789 2 27.185 2 26.4621L2 22.6546H3.57143L3.57143 26.4621C3.57143 26.7031 3.672 26.9247 3.87314 27.1269C4.07533 27.328 4.2969 27.4286 4.53786 27.4286L21.4621 27.4286C21.7031 27.4286 21.9247 27.328 22.1269 27.1269C22.328 26.9247 22.4286 26.7031 22.4286 26.4621L22.4286 22.6546H24L24 26.4621C24 27.185 23.758 27.7884 23.274 28.2724C22.789 28.7575 22.185 29 21.4621 29L4.53786 29Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4976_2403)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 36,
    transform: "matrix(-1 0 0 1 27 0)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnIcons);
export default __webpack_public_path__ + "static/media/BtnIcons.86685fd61313bc504ce7a48d55cd8a72.svg";
export { ForwardRef as ReactComponent };